import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'
import PinCodeField from '../../../../components/PinCodeField'
import {StepHeader} from '../../styles'

const Step3 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Vamos criar uma senha segura
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Digite uma senha numérica com 6 dígitos, não use caracteres sequenciais ou repetidos
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              name="password"
              obfuscation
              component={PinCodeField}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  )
}

export default Step3
